module.exports = __webpack_public_path__ + "static/commercial-fire-blanket-71af2c6d7f080e13251255309f335d38.png";